module.exports = new __parcel__URL__("shatteredcrystals.667df8b3.png").toString();